import i18n from "@/i18n";

export const MONTH_NAMES = [
  { name: String(i18n.global.t("dashboard.leaderboard.filterMonth.monthNames.january")), value: "01" },
  { name: String(i18n.global.t("dashboard.leaderboard.filterMonth.monthNames.february")), value: "02" },
  { name: String(i18n.global.t("dashboard.leaderboard.filterMonth.monthNames.march")), value: "03" },
  { name: String(i18n.global.t("dashboard.leaderboard.filterMonth.monthNames.april")), value: "04" },
  { name: String(i18n.global.t("dashboard.leaderboard.filterMonth.monthNames.may")), value: "05" },
  { name: String(i18n.global.t("dashboard.leaderboard.filterMonth.monthNames.june")), value: "06" },
  { name: String(i18n.global.t("dashboard.leaderboard.filterMonth.monthNames.july")), value: "07" },
  { name: String(i18n.global.t("dashboard.leaderboard.filterMonth.monthNames.august")), value: "08" },
  { name: String(i18n.global.t("dashboard.leaderboard.filterMonth.monthNames.september")), value: "09" },
  { name: String(i18n.global.t("dashboard.leaderboard.filterMonth.monthNames.october")), value: "10" },
  { name: String(i18n.global.t("dashboard.leaderboard.filterMonth.monthNames.november")), value: "11" },
  { name: String(i18n.global.t("dashboard.leaderboard.filterMonth.monthNames.december")), value: "12" }
];

export const FILTER_MONTH_LEADERBOARD_KEYS = {
  LAST_MONTH: "last-month",
  CURRENT_MONTH: "current-month",
  CUSTOM: "custom"
};

export const getMonthTabs = () => {
  const newDate = new Date();
  const currentMonthIndex = newDate.getMonth();
  const currentYear = newDate.getFullYear();
  const monthTabs = {
    previousMonth: {
      ...(currentMonthIndex === 0
        ? MONTH_NAMES[11]
        : MONTH_NAMES[currentMonthIndex - 1]),
      key: FILTER_MONTH_LEADERBOARD_KEYS.LAST_MONTH
    },
    currentMonth: {
      ...MONTH_NAMES[currentMonthIndex],
      key: FILTER_MONTH_LEADERBOARD_KEYS.CURRENT_MONTH
    }
  };

  return {
    monthTabs,
    currentYear,
    currentMonthIndex
  };
};
